import { Injectable } from '@angular/core'
import { Store, StoreConfig } from '@datorama/akita'
import { RegisterSettings } from './register.model'

export interface RegisterState {
  settings: RegisterSettings | null
}

export function createInitialState(): RegisterState {
  return {
    settings: null,
  }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'register' })
export class RegisterStore extends Store<RegisterState> {
  constructor() {
    super(createInitialState())
  }
}
